import { render, staticRenderFns } from "./SmartCardsItem.vue?vue&type=template&id=0c2a8406&lang=pug&"
import script from "./SmartCardsItem.vue?vue&type=script&lang=js&"
export * from "./SmartCardsItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports